<p-speedDial
  *ngIf="visible"
  [model]="items"
  direction="right"
  [transitionDelay]="40"
  buttonClassName="p-button-secondary"
  showIcon="fa fa-ellipsis-h"
  hideIcon="fa fa-times"
></p-speedDial>
